{
  "issuer": "https://si-agroid-identityserver.segestest.dk",
  "jwks_uri": "https://si-agroid-identityserver.segestest.dk/.well-known/openid-configuration/jwks",
  "authorization_endpoint": "https://si-agroid-identityserver.segestest.dk/connect/authorize",
  "token_endpoint": "https://si-agroid-identityserver.segestest.dk/connect/token",
  "userinfo_endpoint": "https://si-agroid-identityserver.segestest.dk/connect/userinfo",
  "end_session_endpoint": "https://si-agroid-identityserver.segestest.dk/connect/endsession",
  "check_session_iframe": "https://si-agroid-identityserver.segestest.dk/connect/checksession",
  "revocation_endpoint": "https://si-agroid-identityserver.segestest.dk/connect/revocation",
  "introspection_endpoint": "https://si-agroid-identityserver.segestest.dk/connect/introspect",
  "device_authorization_endpoint": "https://si-agroid-identityserver.segestest.dk/connect/deviceauthorization",
  "backchannel_authentication_endpoint": "https://si-agroid-identityserver.segestest.dk/connect/ciba",
  "pushed_authorization_request_endpoint": "https://si-agroid-identityserver.segestest.dk/connect/par",
  "require_pushed_authorization_requests": false,
  "frontchannel_logout_supported": true,
  "frontchannel_logout_session_supported": true,
  "backchannel_logout_supported": true,
  "backchannel_logout_session_supported": true,
  "scopes_supported": [
      "openid",
      "email",
      "address",
      "phone",
      "profile",
      "role",
      "cvr",
      "dataident_dcf",
      "dataident_webdyr",
      "upn",
      "dataident_dcfodata",
      "cpr",
      "cvrs",
      "dataident_eartag",
      "debug.aspnetcoresampleapi.full_access",
      "debug.aspnetcoresampleapi.function_x_create",
      "debug.aspnetcoresampleapi.function_x_read",
      "debug.aspnetcoresampleapi.function_x_update",
      "debug.aspnetcoresampleapi.function_x_delete",
      "debug.aspnetcoresampleapi.function_y_full_access",
      "debug.aspnetcoresampleapi.function_y_user_access",
      "debug.aspnetcoresampleapi.function_y_user_full_access",
      "dev.cattle_idden.read",
      "debug.plantapi.full_access",
      "debug.plantapi.farm_create",
      "debug.plantapi.farm_read",
      "debug.plantapi.farm_update",
      "debug.plantapi.farm_delete",
      "debug.cattle_idden.read",
      "devtest.cattle_idden.read",
      "debug.plantapi.tokenexchange",
      "dev.plantapi.full_access",
      "dev.plantapi.farm_create",
      "dev.plantapi.farm_read",
      "dev.plantapi.farm_update",
      "dev.plantapi.farm_delete",
      "dev.plantapi.tokenexchange",
      "debug.cattle_cattlewebapi.api",
      "dev.cattle_cattlewebapi.api",
      "devtest.cattle_cattlewebapi.api",
      "accepttest.cattle_cattlewebapi.api",
      "debug.aspnetcoresampleapi.tokenexchange",
      "debug.samplesamlapi.tokenexchange",
      "dev.plant.farm_create",
      "dev.plant.farm_read",
      "dev.plant.farm_update",
      "dev.plant.farm_delete",
      "dev.plant.tokenexchange",
      "devtest.plant.farm_create",
      "devtest.plant.farm_read",
      "devtest.plant.farm_update",
      "devtest.plant.farm_delete",
      "devtest.plant.tokenexchange",
      "accepttest.cattle_dcfodata.api",
      "accepttest.cattle_dcfodata.tokenexchange",
      "devtest.cattle_dcfodata.api",
      "devtest.cattle_dcfodata.tokenexchange",
      "debug.talomkvaeg.default",
      "debug.talomkvaeg.batch",
      "debug.fakweb.tokenexchange",
      "devtest.talomkvaeg.default",
      "devtest.talomkvaeg.batch",
      "debug.tarokapi.api",
      "dev.tarokapi.api",
      "devtest.tarokapi.api",
      "devtest.farmtime.create",
      "devtest.farmtime.tokenexchange",
      "debug.avance2020.default",
      "dev.avance2020.default",
      "devtest.avance2020.default",
      "debug.cattle_kiip.api",
      "debug.cattle_kiip.tokenexchange",
      "devtest.cattle_dcfodata_temp.api",
      "devtest.cattle_dcfodata_temp.tokenexchange",
      "accepttest.cattle_dcfodata_temp.api",
      "accepttest.cattle_dcfodata_temp.tokenexchange",
      "debug.apirating.default",
      "dev.apirating.default",
      "devtest.apirating.default",
      "debug.geoapi.full_access",
      "debug.qaaapi.full_access",
      "debug.cattle_scsapi.api",
      "debug.cattle_scsapi.tokenexchange",
      "dev.cattle_scsapi.api",
      "dev.cattle_scsapi.tokenexchange",
      "devtest.cattle_scsapi.api",
      "devtest.cattle_scsapi.tokenexchange",
      "accepttest.cattle_scsapi.api",
      "accepttest.cattle_scsapi.tokenexchange",
      "debug.cattle_dcfodata.api",
      "debug.cattle_dcfodata.tokenexchange",
      "debug.cattle_dcfodata_temp.api",
      "debug.cattle_dcfodata_temp.tokenexchange",
      "dev.cattle_dcfodata.api",
      "dev.cattle_dcfodata.tokenexchange",
      "debug.cattle_easycowapi.api",
      "debug.cattle_easycowapi.tokenexchange",
      "dev.cattle_easycowapi.api",
      "dev.cattle_easycowapi.tokenexchange",
      "devtest.cattle_kiip.api",
      "devtest.cattle_kiip.tokenexchange",
      "devtest.cattle_cattlewebapi.tokenexchange",
      "devtest.cattle_easycowapi.api",
      "devtest.cattle_easycowapi.tokenexchange",
      "debug.cattle_cattlewebapi.tokenexchange",
      "dev.cattle_cattlewebapi.tokenexchange",
      "dev.cattle_dcfservices.api",
      "dev.cattle_dcfservices.tokenexchange",
      "dev.qaaapi.full_access",
      "devtest.qaaapi.full_access",
      "dev.geoapi.full_access",
      "devtest.geoapi.full_access",
      "si.tican.default",
      "dev.ldk.default",
      "dev.ldk.tokenexchange",
      "debug.ldk.default",
      "debug.ldk.tokenexchange",
      "devtest.ldk.default",
      "devtest.ldk.tokenexchange",
      "debug.qaaapi.trustedsubsystem",
      "debug.geoapi.trustedsubsystem",
      "dev.geoapi.trustedsubsystem",
      "devtest.geoapi.trustedsubsystem",
      "accepttest.cattle_cattlewebapi.tokenexchange",
      "dev.fluxapi.full_access",
      "dev.fluxapi.trustedsubsystem",
      "debug.fluxapi.full_access",
      "debug.fluxapi.trustedsubsystem",
      "dev.qaaapi.trustedsubsystem",
      "devtest.qaaapi.trustedsubsystem",
      "devtest.fluxapi.full_access",
      "devtest.fluxapi.trustedsubsystem",
      "debug.fvko.tokenexchange",
      "si.fluxapi.full_access",
      "accepttest.tarokapi.api",
      "debug.blazorbffwithswaggerapi.default",
      "si.ldk.default",
      "si.ldk.tokenexchange",
      "accepttest.cattle_easycowapi.api",
      "accepttest.cattle_easycowapi.tokenexchange",
      "accepttest.klimasaf.default",
      "accepttest.klimasaf.tokenexchange",
      "debug.klimasaf.default",
      "debug.klimasaf.tokenexchange",
      "dev.klimasaf.default",
      "dev.klimasaf.tokenexchange",
      "devtest.klimasaf.default",
      "devtest.klimasaf.tokenexchange",
      "debug.klima1.default",
      "debug.klima1.tokenexchange",
      "dev.klima1.default",
      "dev.klima1.tokenexchange",
      "devtest.klima1.default",
      "devtest.klima1.tokenexchange",
      "accepttest.klima1.default",
      "accepttest.klima1.tokenexchange",
      "debug.cattle_dcfodata_batchscheduler.api",
      "debug.cattle_orbit_bffsample_api.api",
      "debug.pdfserviceapi.default",
      "devtest.pdfserviceapi.default",
      "devtest.cattle_dcfservices.api",
      "devtest.cattle_dcfservices.tokenexchange",
      "debug.cattle_orbitapi.api",
      "dev.cattle_orbitapi.api",
      "devtest.cattle_orbitapi.api",
      "accepttest.cattle_orbitapi.api",
      "devtest.plantapi.full_access",
      "devtest.plantapi.farm_create",
      "devtest.plantapi.farm_read",
      "devtest.plantapi.farm_update",
      "devtest.plantapi.farm_delete",
      "devtest.plantapi.tokenexchange",
      "dev.qaaapi.tokenexchange",
      "devtest.qaaapi.tokenexchange",
      "dev.esgreentool.default",
      "dev.esgreentool.tokenexchange",
      "debug.esgreentool.default",
      "debug.esgreentool.tokenexchange",
      "si.userdatabaseapiproxy.full_access",
      "dev.greenplan.access_as_user",
      "stage.greenplan.access_as_user",
      "debug.cattle_fbo.api",
      "debug.cattle_fbo.tokenexchange",
      "dev.cattle_fbo.api",
      "dev.cattle_fbo.tokenexchange",
      "devtest.cattle_fbo.api",
      "devtest.cattle_fbo.tokenexchange",
      "accepttest.cattle_fbo.api",
      "accepttest.cattle_fbo.tokenexchange",
      "si.delegation.delegation",
      "si.delegation.administration",
      "si.delegation.trustedsubsystem",
      "debug.cattle_norforapi.api",
      "dev.cattle_norforapi.api",
      "devtest.cattle_norforapi.api",
      "accepttest.cattle_norforapi.api",
      "debug.cattle_wshandyvik.api",
      "dev.cattle_wshandyvik.api",
      "devtest.cattle_wshandyvik.api",
      "accepttest.cattle_wshandyvik.api",
      "devtest.cattle_ct_api.api",
      "dev.cattle_ct_api.api",
      "debug.cattle_ct_api.api",
      "accepttest.cattle_ct_api.api",
      "debug.cattle_segesjar_api.api",
      "dev.cattle_segesjar_api.api",
      "devtest.cattle_segesjar_api.api",
      "accepttest.cattle_segesjar_api.api",
      "dev.kemiapv.default",
      "debug.kemiapv.default",
      "debug.kemiapv.tokenexchange",
      "dev.kemiapv.tokenexchange",
      "si.samplesamlapi.tokenexchange",
      "si.aspnetcoresampleapi.full_access",
      "si.aspnetcoresampleapi.function_x_create",
      "si.aspnetcoresampleapi.function_x_read",
      "si.aspnetcoresampleapi.function_x_update",
      "si.aspnetcoresampleapi.function_x_delete",
      "si.aspnetcoresampleapi.function_y_full_access",
      "si.aspnetcoresampleapi.function_y_user_access",
      "si.aspnetcoresampleapi.function_y_user_full_access",
      "si.aspnetcoresampleapi.tokenexchange",
      "devtest.labitapi.default",
      "dev.foling.default",
      "debug.plant.farm_create",
      "debug.plant.farm_read",
      "debug.plant.farm_update",
      "debug.plant.farm_delete",
      "debug.plant.tokenexchange",
      "debug.teknologisk.nfts",
      "debug.teknologisk.webtrialsplans",
      "dev.teknologisk.nfts",
      "dev.teknologisk.webtrialsplans",
      "accepttest.labitapi.default",
      "debug.labitapi.default",
      "accepttest.cattle_dcfservices.api",
      "accepttest.cattle_dcfservices.tokenexchange",
      "dev.dataestatedataapi.esg",
      "devtest.dataestatedataapi.esg",
      "dev.teknologisk.emission",
      "debug.teknologisk.emission",
      "preprod.farmtime.client",
      "preprod.farmtime.punchclock",
      "debug.farmtime.client",
      "debug.farmtime.punchclock",
      "debug.cattle_feeding_api.api",
      "dev.cattle_feeding_api.api",
      "devtest.cattle_feeding_api.api",
      "dev.cnhapi.default",
      "dev.cnhapi.tokenexchange",
      "debug.cnhapi.default",
      "debug.cnhapi.tokenexchange",
      "accepttest.cattle_feeding_api.api",
      "debug.cattle_feeding_api.tokenexchange",
      "accepttest.cattle_feeding_api.tokenexchange",
      "dev.cattle_feeding_api.tokenexchange",
      "devtest.cattle_feeding_api.tokenexchange",
      "si.obapi.read",
      "si.consent.glcoa",
      "si.consent.gtalcconsentclient",
      "si.consent.gtalcconsenttemplateadmin",
      "debug.labitexportinvoiceapi.client",
      "devtest.labitexportinvoiceapi.client",
      "accepttest.labitexportinvoiceapi.client",
      "devtest.kemitjek.tokenexchange",
      "debug.cropsapi.all_read",
      "debug.cropsapi.all_read_write_delete",
      "debug.cropsapi.biogas_read_write_delete",
      "debug.cropsapi.crop_read",
      "debug.cropsapi.crop_read_write",
      "debug.cropsapi.delegatedaccess_read_write_delete",
      "debug.cropsapi.farm_read",
      "debug.cropsapi.farm_read_write",
      "debug.cropsapi.field_read",
      "debug.cropsapi.field_read_write",
      "debug.cropsapi.manureanalysis_read_write_delete",
      "debug.cropsapi.nutrieroute_read_write",
      "debug.cropsapi.prescriptionmap_read",
      "debug.cropsapi.producenorm_read",
      "debug.cropsapi.producenormall_read",
      "debug.cropsapi.producenormseed_read",
      "debug.cropsapi.producenormseedfertilizer_read",
      "debug.cropsapi.producenormyield_read",
      "debug.cropsapi.stock_read_write",
      "debug.cropsapi.task_read",
      "debug.cropsapi.task_read_write",
      "debug.cropsapi.task_read_write_delete",
      "debug.cropsapi.watermeasurement_read_write_delete",
      "dev.kemitjek.tokenexchange",
      "debug.farmtime.tokenexchange",
      "preprod.farmtime.tokenexchange",
      "dev.cropsapi.all_read",
      "dev.cropsapi.all_read_write_delete",
      "dev.cropsapi.biogas_read_write_delete",
      "dev.cropsapi.crop_read",
      "dev.cropsapi.crop_read_write",
      "dev.cropsapi.delegatedaccess_read_write_delete",
      "dev.cropsapi.farm_read",
      "dev.cropsapi.farm_read_write",
      "dev.cropsapi.field_read",
      "dev.cropsapi.field_read_write",
      "dev.cropsapi.manureanalysis_read_write_delete",
      "dev.cropsapi.nutrieroute_read_write",
      "dev.cropsapi.prescriptionmap_read",
      "dev.cropsapi.producenorm_read",
      "dev.cropsapi.producenormall_read",
      "dev.cropsapi.producenormseed_read",
      "dev.cropsapi.producenormseedfertilizer_read",
      "dev.cropsapi.producenormyield_read",
      "dev.cropsapi.stock_read_write",
      "dev.cropsapi.task_read",
      "dev.cropsapi.task_read_write",
      "dev.cropsapi.task_read_write_delete",
      "dev.cropsapi.watermeasurement_read_write_delete",
      "devtest.cattle_dms_kvkservice_api.api",
      "devtest.cattle_dms_kvkservice_api.tokenexchange",
      "debug.plant.climatemodelsapi",
      "si.delegation.readalldelegations",
      "dev.plant.climatemodelsapi",
      "debug.cattle_dms_kvkservice_api.api",
      "debug.cattle_dms_kvkservice_api.tokenexchange",
      "devtest.plant.climatemodelsapi",
      "debug.cattle_dcc_api.api",
      "debug.cattle_dcc_api.tokenexchange",
      "dev.cattle_dcc_api.api",
      "dev.cattle_dcc_api.tokenexchange",
      "devtest.cattle_dcc_api.api",
      "devtest.cattle_dcc_api.tokenexchange",
      "accepttest.cattle_dcc_api.api",
      "accepttest.cattle_dcc_api.tokenexchange",
      "dev.myexampleapi.default",
      "si.myexampleapi.default",
      "devtest.myexampleapi.default",
      "accepttest.labitapi.hsm",
      "debug.cattle_mfclimateapi.api",
      "debug.cattle_dcmr_api.api",
      "debug.cattle_dcmr_api.tokenexchange",
      "preprod.ldk.default",
      "preprod.ldk.tokenexchange",
      "dev.cattle_mfclimateapi.api",
      "dev.cattle_dcmr_api.api",
      "dev.cattle_dcmr_api.tokenexchange",
      "devtest.cattle_dcmr_api.api",
      "devtest.cattle_dcmr_api.tokenexchange",
      "accepttest.cattle_dcmr_api.api",
      "accepttest.cattle_dcmr_api.tokenexchange",
      "si.consentapi.glcoa",
      "si.consentapi.administration",
      "si.consentapi.trustedsubsystem",
      "si.consentapi.consentlookup",
      "si.consentapi.templateadmin",
      "si.consentapi.changeconsent",
      "dev.traceitapi.all",
      "accepttest.cattle_mfclimateapi.api",
      "dev.cropsdwhapi.default",
      "si.fluxapi.ica",
      "si.fluxapi.trustedsubsystem",
      "preprod.qaaapi.full_access",
      "preprod.qaaapi.trustedsubsystem",
      "preprod.qaaapi.tokenexchange",
      "dev.traceitprimaryproducerapi.all",
      "preprod.geoapi.full_access",
      "preprod.geoapi.trustedsubsystem",
      "preprod.pdfserviceapi.default",
      "development.medireg.read_schema",
      "development.medireg.write_schema",
      "preprod.fluxapi.full_access",
      "preprod.fluxapi.trustedsubsystem",
      "devtest.cattle_besdyr.api",
      "si.delegation.selfservice",
      "devtest.cropsdwhapi.default",
      "accepttest.cattle_besdyr.api",
      "dev.nftsadmin.default",
      "local.nftsadmin.default",
      "devtest.cropsapi.all_read",
      "devtest.cropsapi.all_read_write_delete",
      "devtest.cropsapi.biogas_read_write_delete",
      "devtest.cropsapi.crop_read",
      "devtest.cropsapi.crop_read_write",
      "devtest.cropsapi.delegatedaccess_read_write_delete",
      "devtest.cropsapi.farm_read",
      "devtest.cropsapi.farm_read_write",
      "devtest.cropsapi.field_read",
      "devtest.cropsapi.field_read_write",
      "devtest.cropsapi.manureanalysis_read_write_delete",
      "devtest.cropsapi.nutrieroute_read_write",
      "devtest.cropsapi.prescriptionmap_read",
      "devtest.cropsapi.producenorm_read",
      "devtest.cropsapi.producenormall_read",
      "devtest.cropsapi.producenormseed_read",
      "devtest.cropsapi.producenormseedfertilizer_read",
      "devtest.cropsapi.producenormyield_read",
      "devtest.cropsapi.stock_read_write",
      "devtest.cropsapi.task_read",
      "devtest.cropsapi.task_read_write",
      "devtest.cropsapi.task_read_write_delete",
      "devtest.cropsapi.watermeasurement_read_write_delete",
      "accepttest.cattle_dms_kvkservice_api.api",
      "accepttest.cattle_dms_kvkservice_api.tokenexchange",
      "dev.cropsweatherapi.default",
      "debugfeature.cattle_cattlewebapi.api",
      "debugfeature.cattle_cattlewebapi.tokenexchange",
      "debug.vetlab.default",
      "offline_access"
  ],
  "claims_supported": [
      "sub",
      "email",
      "email_verified",
      "address",
      "phone_number",
      "phone_number_verified",
      "name",
      "family_name",
      "given_name",
      "middle_name",
      "nickname",
      "preferred_username",
      "profile",
      "picture",
      "website",
      "gender",
      "birthdate",
      "zoneinfo",
      "locale",
      "updated_at",
      "role",
      "cvr_number_verified",
      "dataident_dcf",
      "dataident_webdyr",
      "upn",
      "dataident_dcfodata",
      "cpr_number_verified",
      "cvr_numbers_verified",
      "dataident_eartag"
  ],
  "grant_types_supported": [
      "authorization_code",
      "client_credentials",
      "refresh_token",
      "implicit",
      "password",
      "urn:ietf:params:oauth:grant-type:device_code",
      "urn:openid:params:grant-type:ciba",
      "urn:ietf:params:oauth:grant-type:token-exchange"
  ],
  "response_types_supported": [
      "code",
      "token",
      "id_token",
      "id_token token",
      "code id_token",
      "code token",
      "code id_token token"
  ],
  "response_modes_supported": [
      "form_post",
      "query",
      "fragment"
  ],
  "token_endpoint_auth_methods_supported": [
      "client_secret_basic",
      "client_secret_post"
  ],
  "id_token_signing_alg_values_supported": [
      "RS256"
  ],
  "subject_types_supported": [
      "public"
  ],
  "code_challenge_methods_supported": [
      "plain",
      "S256"
  ],
  "request_parameter_supported": true,
  "request_object_signing_alg_values_supported": [
      "RS256",
      "RS384",
      "RS512",
      "PS256",
      "PS384",
      "PS512",
      "ES256",
      "ES384",
      "ES512",
      "HS256",
      "HS384",
      "HS512"
  ],
  "prompt_values_supported": [
      "none",
      "login",
      "consent",
      "select_account"
  ],
  "authorization_response_iss_parameter_supported": true,
  "backchannel_token_delivery_modes_supported": [
      "poll"
  ],
  "backchannel_user_code_parameter_supported": true,
  "dpop_signing_alg_values_supported": [
      "RS256",
      "RS384",
      "RS512",
      "PS256",
      "PS384",
      "PS512",
      "ES256",
      "ES384",
      "ES512"
  ]
}
